import {ADD_HISTORY_STEP} from '../actionTypes/actiontypes';
import {ADD_PATH_STEP} from '../actionTypes/actiontypes';
import {ADD_FILE} from '../actionTypes/actiontypes';

export const addHistoryStep = (step) => ({ type: ADD_HISTORY_STEP, payload: step });
export const addPathStep = (step) => ({ type: ADD_PATH_STEP, payload: step });
export const addFile = (file) => ({type: ADD_FILE, payload:file});